import type { ReactNode } from 'react';

export const symbol_device_hub: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-150v-120q0-12.75 8.63-21.38Q137.25-300 150-300h124l176-176v-149q-35-12-57.5-40.65T370-730q0-45.83 32.12-77.92 32.12-32.08 78-32.08T558-807.92q32 32.09 32 77.92 0 35.7-22.5 64.35Q545-637 510-625v149l176 176h124q12.75 0 21.38 8.62Q840-282.75 840-270v120q0 12.75-8.62 21.37Q822.75-120 810-120H690q-12.75 0-21.37-8.63Q660-137.25 660-150v-86L480-416 300-236v86q0 12.75-8.62 21.37Q282.75-120 270-120H150q-12.75 0-21.37-8.63Q120-137.25 120-150Z"
		/>
	</svg>
);
